import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90ac59d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tools-left" }
const _hoisted_2 = { class: "content" }

import { PropType, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { ContextmenuItem } from '@/components/Contextmenu/types'
import { enterFullscreen } from '@/utils/fullscreen'
import useScreening from '@/hooks/useScreening'
import useExecPlay from './hooks/useExecPlay'
import useSlideSize from './hooks/useSlideSize'
import useFullscreen from './hooks/useFullscreen'

import ScreenSlideList from './ScreenSlideList.vue'
import SlideThumbnails from './SlideThumbnails.vue'
import WritingBoardTool from './WritingBoardTool.vue'
import CountdownTimer from './CountdownTimer.vue'
import { Tooltip } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseView',
  props: {
  changeViewMode: {
    type: Function as PropType<(mode: 'base' | 'presenter') => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { slides, slideIndex } = storeToRefs(useSlidesStore())

const {
  autoPlayTimer,
  autoPlay,
  closeAutoPlay,
  mousewheelListener,
  touchStartListener,
  touchEndListener,
  turnPrevSlide,
  turnNextSlide,
  turnSlideToIndex,
  turnSlideToId,
  execPrev,
  execNext,
  animationIndex,
} = useExecPlay()

const { slideWidth, slideHeight } = useSlideSize()
const { exitScreening } = useScreening()
const { fullscreenState, manualExitFullscreen } = useFullscreen()

const rightToolsVisible = ref(false)
const writingBoardToolVisible = ref(false)
const timerlVisible = ref(false)
const slideThumbnailModelVisible = ref(false)
const laserPen = ref(false)

const contextmenus = (): ContextmenuItem[] => {
  return [
    {
      text: '上一页',
      subText: '↑ ←',
      disable: slideIndex.value <= 0,
      handler: () => turnPrevSlide(),
    },
    {
      text: '下一页',
      subText: '↓ →',
      disable: slideIndex.value >= slides.value.length - 1,
      handler: () => turnNextSlide(),
    },
    {
      text: '第一页',
      disable: slideIndex.value === 0,
      handler: () => turnSlideToIndex(0),
    },
    {
      text: '最后一页',
      disable: slideIndex.value === slides.value.length - 1,
      handler: () => turnSlideToIndex(slides.value.length - 1),
    },
    { divider: true },
    {
      text: '显示工具栏',
      handler: () => rightToolsVisible.value = true,
    },
    {
      text: '查看所有幻灯片',
      handler: () => slideThumbnailModelVisible.value = true,
    },
    {
      text: '画笔工具',
      handler: () => writingBoardToolVisible.value = true,
    },
    {
      text: '演讲者视图',
      handler: () => props.changeViewMode('presenter'),
    },
    { divider: true },
    {
      text: autoPlayTimer.value ? '取消自动放映' : '自动放映',
      handler: autoPlayTimer.value ? closeAutoPlay : autoPlay,
    },
    {
      text: '结束放映',
      subText: 'ESC',
      handler: exitScreening,
    },
  ]
}

return (_ctx: any,_cache: any) => {
  const _component_IconLeftTwo = _resolveComponent("IconLeftTwo")!
  const _component_IconRightTwo = _resolveComponent("IconRightTwo")!
  const _component_IconWrite = _resolveComponent("IconWrite")!
  const _component_IconMagic = _resolveComponent("IconMagic")!
  const _component_IconStopwatchStart = _resolveComponent("IconStopwatchStart")!
  const _component_IconListView = _resolveComponent("IconListView")!
  const _component_IconOffScreenOne = _resolveComponent("IconOffScreenOne")!
  const _component_IconFullScreenOne = _resolveComponent("IconFullScreenOne")!
  const _component_IconPower = _resolveComponent("IconPower")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-view", { 'laser-pen': laserPen.value }])
  }, [
    _withDirectives(_createVNode(ScreenSlideList, {
      slideWidth: _unref(slideWidth),
      slideHeight: _unref(slideHeight),
      animationIndex: _unref(animationIndex),
      turnSlideToId: _unref(turnSlideToId),
      manualExitFullscreen: _unref(manualExitFullscreen),
      onWheel: _cache[0] || (_cache[0] = $event => _unref(mousewheelListener)($event)),
      onTouchstart: _cache[1] || (_cache[1] = $event => _unref(touchStartListener)($event)),
      onTouchend: _cache[2] || (_cache[2] = $event => _unref(touchEndListener)($event))
    }, null, 8, ["slideWidth", "slideHeight", "animationIndex", "turnSlideToId", "manualExitFullscreen"]), [
      [_directive_contextmenu, contextmenus]
    ]),
    (slideThumbnailModelVisible.value)
      ? (_openBlock(), _createBlock(SlideThumbnails, {
          key: 0,
          turnSlideToIndex: _unref(turnSlideToIndex),
          onClose: _cache[3] || (_cache[3] = ($event: any) => (slideThumbnailModelVisible.value = false))
        }, null, 8, ["turnSlideToIndex"]))
      : _createCommentVNode("", true),
    (writingBoardToolVisible.value)
      ? (_openBlock(), _createBlock(WritingBoardTool, {
          key: 1,
          slideWidth: _unref(slideWidth),
          slideHeight: _unref(slideHeight),
          onClose: _cache[4] || (_cache[4] = ($event: any) => (writingBoardToolVisible.value = false))
        }, null, 8, ["slideWidth", "slideHeight"]))
      : _createCommentVNode("", true),
    (timerlVisible.value)
      ? (_openBlock(), _createBlock(CountdownTimer, {
          key: 2,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (timerlVisible.value = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_IconLeftTwo, {
        class: "tool-btn",
        theme: "two-tone",
        fill: ['#111', '#fff'],
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(execPrev)()))
      }),
      _createVNode(_component_IconRightTwo, {
        class: "tool-btn",
        theme: "two-tone",
        fill: ['#111', '#fff'],
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(execNext)()))
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["tools-right", { 'visible': rightToolsVisible.value }]),
      onMouseleave: _cache[16] || (_cache[16] = ($event: any) => (rightToolsVisible.value = false)),
      onMouseenter: _cache[17] || (_cache[17] = ($event: any) => (rightToolsVisible.value = true))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "tool-btn page-number",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (slideThumbnailModelVisible.value = true))
        }, "幻灯片 " + _toDisplayString(_unref(slideIndex) + 1) + " / " + _toDisplayString(_unref(slides).length), 1),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.3,
          title: "画笔工具"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconWrite, {
              class: "tool-btn",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (writingBoardToolVisible.value = true))
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.3,
          title: "激光笔"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconMagic, {
              class: _normalizeClass(["tool-btn", { 'active': laserPen.value }]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (laserPen.value = !laserPen.value))
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.3,
          title: "计时器"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconStopwatchStart, {
              class: _normalizeClass(["tool-btn", { 'active': timerlVisible.value }]),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (timerlVisible.value = !timerlVisible.value))
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.3,
          title: "演讲者视图"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconListView, {
              class: "tool-btn",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (__props.changeViewMode('presenter')))
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.3,
          title: _unref(fullscreenState) ? '退出全屏' : '进入全屏'
        }, {
          default: _withCtx(() => [
            (_unref(fullscreenState))
              ? (_openBlock(), _createBlock(_component_IconOffScreenOne, {
                  key: 0,
                  class: "tool-btn",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(manualExitFullscreen)()))
                }))
              : (_openBlock(), _createBlock(_component_IconFullScreenOne, {
                  key: 1,
                  class: "tool-btn",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(enterFullscreen)()))
                }))
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.3,
          title: "结束放映"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconPower, {
              class: "tool-btn",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(exitScreening)()))
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ])
    ], 34)
  ], 2))
}
}

})